"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Checkbox = require("./Checkbox.styles");
var _excluded = ["indeterminate"];
/**
 * A native input element with
 * [`type="checkbox"`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox).
 * In general, you will want to use this with the LabeledControl component.
 *
 * @since 1.9.0
 */

var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var indeterminate = _ref.indeterminate,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var defaultInnerRef = (0, _react.useRef)();
  var innerRef = forwardedRef || defaultInnerRef;
  (0, _react.useEffect)(function () {
    if (innerRef.current) {
      innerRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate, innerRef]);
  return /*#__PURE__*/_react.default.createElement(_Checkbox.StyledCheckbox, (0, _extends2.default)({
    "aria-checked": indeterminate ? 'mixed' : undefined,
    ref: innerRef
  }, rest));
});
exports.Checkbox = Checkbox;
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @deprecated Use the native `id` attributed if you want to manually set the id. Otherwise,
   * let LabeledControl set this for you.
   */
  controlId: _propTypes.default.string,
  /**
   * Sets the checked state of the input and uses it as a
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   */
  checked: _propTypes.default.bool,
  /**
   * Sets the checked state of the input and uses it as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   */
  defaultChecked: _propTypes.default.bool,
  /**
   * Displays the input in a disabled state. Can also be inherited from a FieldSet parent.
   */
  disabled: _propTypes.default.bool,
  /**
   * When true, the checkbox is shown in the indeterminate state (also known as a
   * "partial check"). It's most commonly used above a list of related checkboxes
   * to indicate that some — but not all — of them are checked.
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#Indeterminate
   *
   * It's recommended that you only use the indeterminate state with controlled checkboxes.
   *
   * @since 8.17.0
   */
  indeterminate: _propTypes.default.bool,
  /**
   * Used for hiding the checkbox while maintaining accessibility
   * (primarily used by the Switch component which overrides styles):
   * https://accessibilitytips.com/2008/03/04/positioning-content-offscreen/
   *
   * @ignore
   */
  offscreen: _propTypes.default.bool,
  /**
   * Indicates the input is required. Can also be inherited from a FieldSet parent.
   */
  required: _propTypes.default.bool,
  /**
   * The HTML input type.
   * @ignore
   */
  type: _propTypes.default.string
} : {};
Checkbox.defaultProps = {
  type: 'checkbox'
};